import { useEffect } from 'react';
import { getUserLocation } from './user-location-api';
import { UserLocationObj } from './UserLocationContext';
import { useStaticQuery, graphql } from 'gatsby';

const UserLocation = ({
    setUserLocation,
    userLocation,
}: {
    setUserLocation: (userLocation: UserLocationObj) => void;
    userLocation: UserLocationObj;
}) => {
    useEffect(() => {
        if (userLocation.isFallback) {
            getUserLocation().then((userLocation) => userLocation && setUserLocation(userLocation));
        }
    }, [userLocation, setUserLocation]);

    return null;
};
export default UserLocation;
